import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { Plus, Trash2 } from 'lucide-react';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import { REVENUE_MAX_COUNT } from '../../utils/const';
import ConfirmationModal from '../../components/ConfirmationModal';
import GlobalContext from '../../utils/GlobalContext';

export default function RevenueModelCard({
  title,
  addNewLabel,
  revenues,
  className,
  editMode = false,
  titleStyle,
  textStyle,
  backgroundCard,
  titleColor,
}) {
  const {
    revenue: { addRevenue, updateRevenue, removeRevenue },
  } = useDispatch();

  const { locales } = useContext(GlobalContext);

  return (
    <div
      className={classNames('bmc-page-revmodel relative', className)}
      style={{ background: backgroundCard }}
    >
      <div
        className={`bmc-page-revmodel-title ${titleStyle} custom-font-title`}
        style={{ color: titleColor }}
      >
        {title}
      </div>

      <table className="w-full">
        <thead>
          <tr className="flex">
            <th
              className={`leading-[1.25rem] font-medium h-[4.375rem] pl-2 flex justify-start items-center ${
                editMode ? 'w-2/5' : 'w-1/2'
              }`}
            >
              {locales.costRevenue.intro.revenueCard.revenueModel}
            </th>
            <th
              className={`leading-[1.25rem] font-medium h-[4.375rem] pl-2 flex justify-start items-center ${
                editMode ? 'w-2/5' : 'w-1/2'
              }`}
            >
              {locales.costRevenue.intro.revenueCard.explainStrategy}
            </th>
            {editMode && revenues.length > 1 && (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <th className="leading-[1.25rem] font-medium h-[4.375rem] pl-2 w-1/5" />
            )}
          </tr>
        </thead>

        <tbody>
          {revenues.map(({ id, name, description }) =>
            editMode ? (
              <tr key={id} className="flex">
                <td className="p-[0.625rem] w-2/5">
                  <Textarea
                    value={name}
                    delay={700}
                    className={`bmc-form-textarea ${textStyle} custom-font-body`}
                    onChange={(e) =>
                      updateRevenue({ id, name: 'name', value: e.target.value })
                    }
                  />
                </td>
                <td className="p-[0.625rem] w-2/5">
                  <Textarea
                    value={description}
                    delay={700}
                    className={`bmc-form-textarea ${textStyle} custom-font-body`}
                    onChange={(e) =>
                      updateRevenue({
                        id,
                        name: 'description',
                        value: e.target.value,
                      })
                    }
                  />
                </td>
                {revenues.length > 1 && (
                  <td className="p-[0.625rem] w-1/5">
                    <ConfirmationModal
                      className="ml-3 hover:bg-muted-lighter/60 text-muted-darker"
                      body={locales.common.deleteConfirmation}
                      confirmText="Delete"
                      onConfirm={() => removeRevenue({ id })}
                      buttonAriaLabel="Delete"
                    >
                      <Trash2 className="w-6 min-w-6 h-auto" />
                    </ConfirmationModal>
                  </td>
                )}
              </tr>
            ) : (
              <tr className="flex">
                <td className="flex-1 pl-2 w-1/2">{name}</td>
                <td className="flex-1 pl-2 w-1/2">{description}</td>
              </tr>
            ),
          )}
        </tbody>
      </table>

      {editMode && revenues.length < REVENUE_MAX_COUNT && (
        <Button variant="outline" onClick={addRevenue} className="w-full">
          <Plus className="w-7 h-auto" />
          {addNewLabel}
        </Button>
      )}
    </div>
  );
}
